var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99346 0H8.00654C12.4204 0 16 3.48546 16 7.78335V8.21665C16 12.5145 12.4204 16 8.00654 16H7.99346C3.57955 16 0 12.5145 0 8.21665V7.78335C0 3.48546 3.57955 0 7.99346 0Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3169 6.01291C11.291 6.04153 11.2586 6.06378 11.223 6.0765C11.1873 6.0924 11.1485 6.09876 11.1096 6.09876H3.77471C3.51564 6.09876 3.38287 5.78081 3.56422 5.59004L4.76889 4.33414C4.7948 4.30553 4.82718 4.28327 4.86604 4.26737C4.90167 4.25148 4.94053 4.24512 4.97939 4.24512H12.3434C12.6057 4.24512 12.7353 4.56625 12.5507 4.75701L11.3169 6.01291ZM11.3169 11.6279C11.2618 11.6819 11.1873 11.7137 11.1096 11.7137H3.77471C3.51564 11.7137 3.38287 11.4021 3.56422 11.2177L4.76889 9.99045C4.7948 9.96184 4.83042 9.93958 4.86604 9.92686C4.90167 9.91096 4.94053 9.9046 4.97939 9.9046H12.3434C12.6057 9.9046 12.7353 10.2194 12.5507 10.4038L11.3169 11.6279ZM11.3169 7.16071C11.2618 7.10666 11.1873 7.07486 11.1096 7.07486H3.77471C3.51564 7.07486 3.38287 7.38645 3.56422 7.57086L4.76889 8.79814C4.7948 8.82676 4.83042 8.84902 4.86604 8.86173C4.90167 8.87763 4.94053 8.88399 4.97939 8.88399H12.3434C12.6057 8.88399 12.7353 8.56922 12.5507 8.38481L11.3169 7.16071Z",
    fill: "url(#paint0_linear_24984_14056)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24984_14056",
    x1: 4.04039,
    y1: 11.8069,
    x2: 11.9101,
    y2: 4.00326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF41E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10F2B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.c643dc7312730a0bca68ed38235f5b60.svg";
export { ForwardRef as ReactComponent };